import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import Counter from '../components/common/Counter';
import Button from '../components/common/Button';
import Toast from '../components/common/Toast';
import { useDispatch } from 'react-redux';
import { useUserState } from '../contexts/UserContext';
import { addCart, deleteCart } from '../store/actions';

const Wrapper = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 80px;
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Container = styled.div`
  /* width: 510px; */
  display: flex;
  flex-direction: column;
`;

const ButtonBox = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const Title = styled.div`
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 25px;
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 18px;
`;

const Detail = styled.div`
  height: 180px;
  background-color: #eeeeee;
  margin: 10px 0 10px 0;
  border-radius: 10px;
  padding: 10px;
`;

const Badge = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  background: ${({ $type }) =>
    ($type === 'sold_out' || $type === 'discontinued') ? '#fef2f2' : '#eff6ff'};
  color: ${({ $type }) =>
    ($type === 'sold_out' || $type === 'discontinued') ? '#dc2626' : '#2563eb'};
`;

const StockRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

const ProductDetailPage = () => {
  const dispatch = useDispatch();
  const { user } = useUserState();

  const [product, setProduct] = useState({});
  const { productId } = useParams();

  const getDetailById = async (id) => {
    try {
      const { data } = await axios.get(`/api/products/productlist/${id}`);
      data.count = 1;
      setProduct(data);
    } catch (e) {
      console.log(e);
    }
  };

  const [toast, setToast] = useState(false);
  const _handleClick = () => {
    setToast(!toast);
  };
  const [count, setCount] = useState(1);
  const _handleChange = (count) => {
    setCount(count);
    setProduct({ ...product, count: count });
  };

  useEffect(() => {
    getDetailById(productId);
  }, [productId]);

  return (
    <>
      <Wrapper>
        <img
          src={product.img}
          alt="thumbnail"
          style={{
            marginRight: '20px',
            width: '400px',
            height: '400px',
            border: '1px solid gray',
          }}
        />
        <Container>
          <StockRow>
            {product.stock_status === 'sold_out' && <Badge $type="sold_out">품절</Badge>}
            {product.stock_status === 'discontinued' && <Badge $type="discontinued">단종</Badge>}
            {product.stock_quantity != null && product.stock_quantity > 0 && (
              <Badge $type="stock">재고 {product.stock_quantity}개</Badge>
            )}
            {product.stock_quantity === 0 && product.stock_status !== 'sold_out' && product.stock_status !== 'discontinued' && (
              <Badge $type="sold_out">재고 없음</Badge>
            )}
          </StockRow>
          <Title>{product.product_name}</Title>
          <Text style={{ color: 'gray', marginBottom: '26px' }}>
            {product.main_category} | {product.sub_category}
          </Text>
          <Detail>{product.description}</Detail>
          <RowWrapper style={{ justifyContent: 'space-between' }}>
            <RowWrapper>
              <Text style={{ marginRight: '10px' }}>수량</Text>
              <Counter count={count} onChange={_handleChange} />
            </RowWrapper>
            <RowWrapper>
              <Text style={{ marginRight: '10px' }}>총 금액</Text>
              <Text style={{ fontSize: '20px' }}>
                {(count * product[user.level]).toLocaleString('ko-KR')}
              </Text>
            </RowWrapper>
          </RowWrapper>
          <ButtonBox>
            <Button
              width="510"
              onClick={() => {
                _handleClick();
                dispatch(addCart(user.level, product));
              }}
            >
              장바구니 담기
            </Button>
          </ButtonBox>
        </Container>
      </Wrapper>
      {toast && (
        <Toast _handleToast={_handleClick}>제품이 장바구니에 담겼습니다</Toast>
      )}
    </>
  );
};

export default ProductDetailPage;
